import { FC, useEffect, useState } from 'react'
import { Swiper as ReactSwiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Keyboard } from 'swiper'

import VideoPlayer from './VideoPlayer'
import { ImageCarouselItem } from '../../../types/Content'

interface ImageCarouselProps {
  shortCode: string
  items?: ImageCarouselItem[]
}

const ImageCarousel: FC<ImageCarouselProps> = ({ items, shortCode }) => {
  const [swiper, setSwiper] = useState<SwiperCore>()

  useEffect(() => {
    swiper?.slideTo(0, 0, false)
  }, [swiper, shortCode])

  const baseUrl = `${process.env.REACT_APP_BASE_URL}/media`
  const images = items?.map((item, index) => {
    if (item === 'GraphVideo') {
      return <VideoPlayer url={`${baseUrl}/${shortCode}_${index + 1}.mp4`} />
    } else {
      return (
        <img
          style={{ width: '100%' }}
          src={`${baseUrl}/${shortCode}_${index + 1}.jpg`}
          alt=""
        />
      )
    }
  })

  return (
    <ReactSwiper
      onSwiper={setSwiper}
      modules={[Keyboard, Pagination]}
      keyboard
      pagination
      style={{ width: '100%' }}
      nested
    >
      {images?.map((element, index) => (
        <SwiperSlide key={index}>{element}</SwiperSlide>
      ))}
    </ReactSwiper>
  )
}

export default ImageCarousel
